import { AccountProperty } from 'app/services/api/models/AccountProperty';

export enum ScreenEnum {
  dashboard = 'dashboard',
  driverOptions = 'driverOptions',
}

export enum ScreenOrientationEnum {
  portrait = 'portrait',
  landscape = 'landscape',
}

export type ButtonObjectType = {
  name: string;
  key: string;
  cssClass: string;
};

export enum ResetEnum {
  landScapeDriverOptions = 'landScapeDriverOptions',
  portraitDriverOptions = 'portraitDriverOptions',
  landScapeDashboard = 'landScapeDashboard',
  portraitDashboard = 'portraitDashboard',
}

export type DriverOptionsLandscapeButtons = {
  options_btn0: ButtonObjectType;
  options_btn1: ButtonObjectType;
  options_btn2: ButtonObjectType;
  options_btn3: ButtonObjectType;
  options_btn4: ButtonObjectType;
  options_btn5: ButtonObjectType;
  options_btn6: ButtonObjectType;
  options_btn7: ButtonObjectType;
  options_btn8: ButtonObjectType;
  options_btn9: ButtonObjectType;
  options_btn10: ButtonObjectType;
};

export type DashboardButtons = {
  dashboard_btn0: ButtonObjectType;
  dashboard_btn1: ButtonObjectType;
  dashboard_btn2: ButtonObjectType;
  dashboard_btn3: ButtonObjectType;
  dashboard_btn4: ButtonObjectType;
  dashboard_btn5: ButtonObjectType;
};

export type ButtonLayoutValue = {
  mainDashboard: DashboardButtons;
  driverOptions: DriverOptionsLandscapeButtons;
};

export type ButtonEditorState = {
  screen: ScreenEnum;
  orientation: ScreenOrientationEnum;
  landScape: AccountProperty | null;
  portrait: AccountProperty | null;
  workingLandscape: ButtonLayoutValue;
  workingPortrait: ButtonLayoutValue;
  workingLayoutsSeeded: boolean;
};

export type ContextStateType = {
  landscape: AccountProperty[] | undefined;
  portrait: AccountProperty[] | undefined;
  isFetching: boolean;
};
